// Made by crown7367 on Discord
(() => {
  const brandValues = new Set(['starsuniform', 'uniform warehouse source', 'stars uniform']);

  const cleanText = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const normalize = (value) => cleanText(value).toLowerCase();

  const cleanBrandFilters = () => {
    document.querySelectorAll('input[name="filter.p.vendor"]').forEach((input) => {
      const facetGroup = input.closest('details, .facets__disclosure, .mobile-facets__details');
      if (facetGroup) facetGroup.remove();
    });
  };

  const normalizeBrandText = () => {
    document.querySelectorAll('.caption-with-letter-spacing, .product__text, .card-information .caption').forEach((element) => {
      const text = normalize(element.textContent);
      if (!brandValues.has(text)) return;

      if (text === 'stars uniform' && element.dataset.starsVendorCleaned === 'true') return;
      if (text !== 'stars uniform') {
        element.textContent = 'Stars Uniform';
      }
      element.setAttribute('data-stars-vendor-cleaned', 'true');
    });
  };

  const cleanPageCards = () => {
    document.querySelectorAll('.article-card-wrapper .card--text').forEach((card) => {
      card.style.setProperty('--ratio-percent', 'auto');
    });
  };

  const removePreviewBlocks = () => {
    document.querySelectorAll('.stars-uw-import-preview').forEach((section) => {
      section.remove();
    });
  };

  const runCleanup = () => {
    cleanBrandFilters();
    normalizeBrandText();
    cleanPageCards();
    removePreviewBlocks();
  };

  runCleanup();
  document.addEventListener('DOMContentLoaded', runCleanup);

  if (document.documentElement) {
    new MutationObserver(runCleanup).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
})();
